import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule
} from "vuex-module-decorators";
import { login, getUserInfo, doRefreshToken } from "@/api/users";
import {
  getToken,
  setToken,
  removeToken,
  getRefreshToken,
  setRefresgToken,
  removeRefreshToken
} from "@/utils/cookies";
import store from "@/store";

export interface IUserState {
  token: string;
  refreshToken: string;
  name: string;
  avatar: string;
  roles: string[];
  identityAuth: boolean;
}

@Module({ dynamic: true, store, name: "user" })
class User extends VuexModule {
  public userInfo: IUserState = {
    token: getToken() || "",
    refreshToken: getRefreshToken() || "",
    name: "",
    avatar: "",
    roles: [],
    identityAuth: true
  };

  // public token = getToken() || "";
  // public name = "";
  // public avatar = "";
  // public introduction = "";
  // public roles: string[] = [];

  @Mutation
  private SET_TOKEN(token: string) {
    this.userInfo.token = token;
    // this.token = token;
  }

  @Mutation
  private SET_REFRESHTOKEN(refreshToken: string) {
    this.userInfo.refreshToken = refreshToken;
    // this.token = token;
  }

  @Mutation
  private SET_NAME(name: string) {
    this.userInfo.name = name;
    // this.name = name;
  }

  @Mutation
  private SET_AVATAR(avatar: string) {
    this.userInfo.avatar = avatar;
    // this.avatar = avatar;
  }

  @Mutation
  private SET_ROLES(roles: string[]) {
    this.userInfo.roles = roles;
    // this.roles = roles;
  }

  @Mutation
  private SET_IDENTITYAUTH(identityAuth: boolean) {
    this.userInfo.identityAuth = identityAuth;
    // this.roles = roles;
  }

  @Mutation
  public GetSessionLoginInfo() {
    const session = sessionStorage.getItem("Evi_Platform_Store");
    if (session) {
      const sessionVal = JSON.parse(
        sessionStorage.getItem("Evi_Platform_Store") as string
      );
      const token = this.userInfo.token;
      const refreshToken = this.userInfo.refreshToken;
      this.userInfo = sessionVal;
      this.userInfo.token = token;
      this.userInfo.refreshToken = refreshToken;
    }
  }

  @Action
  public SetIdentityAuth(identityAuth: boolean) {
    this.SET_IDENTITYAUTH(identityAuth);
    // this.roles = roles;
  }

  @Action
  public SetAvatar(avatar: string) {
    this.SET_AVATAR(avatar);
  }

  @Action
  public async Login(userInfo: { account: string; password: string }) {
    let { account, password } = userInfo;
    account = account.trim();
    const { data } = await login({ account, password });
    setToken(data.token);
    setRefresgToken(data.refreshToken);
    this.SET_TOKEN(data.token);
    this.SET_REFRESHTOKEN(data.refreshToken);
  }

  @Action
  public async RefreshToen() {
    const token = this.userInfo.token;
    const refreshToken = this.userInfo.refreshToken;
    await doRefreshToken({ token, refreshToken })
      .then(res => {
        setToken(res.data.token);
        setRefresgToken(res.data.refreshToken);
        this.SET_TOKEN(res.data.token);
        this.SET_REFRESHTOKEN(res.data.refreshToken);
      })
      .catch(() => {
        this.SET_REFRESHTOKEN("");
      });
  }

  @Action
  public Clear() {
    this.SET_TOKEN("");
    this.SET_REFRESHTOKEN("");
    this.SET_NAME("");
    this.SET_AVATAR("");
    this.SET_ROLES([]);
  }

  @Action
  public ResetToken() {
    removeToken();
    removeRefreshToken();
    this.Clear();
    sessionStorage.removeItem("Evi_Platform_Store");
  }

  @Action
  public async GetUserInfo() {
    console.log("DoGetUserInfo");
    console.log(this.userInfo.token);
    if (this.userInfo.token === "") {
      throw Error("GetUserInfo: token is undefined!");
    }
    console.log(this.userInfo.token);
    const { data } = await getUserInfo();
    if (!data) {
      throw Error("Verification failed, please Login again.");
    }
    // const { roles, name, avatar, introduction } = data.user;
    const { memberName, nickName, avatar } = data;
    console.log(data);

    // roles must be a non-empty array
    // if (!roles || roles.length <= 0) {
    //   throw Error("GetUserInfo: roles must be a non-null array!");
    // }
    // this.SET_ROLES(roles);
    this.SET_NAME(memberName);
    this.SET_AVATAR(avatar);
    // this.SET_AVATAR(avatar);
    // this.SET_INTRODUCTION(introduction);
  }

  @Action
  public async LogOut() {
    // if (this.token === "") {
    //   throw Error("LogOut: token is undefined!");
    // }
    // await logout();
    removeToken();
    removeRefreshToken();
    this.Clear();
    sessionStorage.removeItem("Evi_Platform_Store");
  }
}

export const UserModule = getModule(User);
